import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  .ant-pagination-item {
    color: #5e6278 !important;
    border: 1px solid transparent !important;
    &:hover {
      color: #065ad8 !important;
    }
  }
  .ant-pagination-item-active {
    font-weight: 500;
    ${
      "" /* background: #7e78ef !important;
    border-color: transparent !important; */
    }
    color: #FFF !important;
    border-radius: 0.65rem !important;
    &:hover {
      color: #fff !important;
    }
  }
  .ant-pagination-item-link {
    color: #5e6278 !important;
    border-color: transparent !important;
    span {
      position: relative;
      top: -2px;
    }
    &:hover {
      color: #1f97d3 !important;
    }
  }
  .ant-pagination-item-active {
    ${
      "" /* background-color: #7e78ef !important;
    border-color: #7e78ef !important; */
    }
    color: #FFF !important;
  }
  .ant-pagination-item-active {
    background-color: #1f97d3 !important;
    border-color: #1f97d3 !important;
  }
  .ant-pagination-item {
    &:hover {
      color: #1f97d3 !important;
      background-color: rgb(239 127 177 / 6%) !important;
    }
  }

  .ant-select .ant-select-selector {
    background-color:#1f97d33d !important
    border-radius: 0.65rem;
    border: 1px solid #1f97d396 !important;
    color: #000 !important;
  }
  .ant-pagination-item-link span{
    top : 0px !important
  }
`;

export default Wrapper;
